
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { AlButton } from '~/components/ui'

export interface BusinessReview {
  logoSrc: string,
  text: string,
  address: string,
  to: string,
}

@Component({
  components: { AlButton },
})
export default class B2bReview extends Vue {
  @Prop({ type: String, required: true })
  readonly logoSrc!: string

  @Prop({ type: String, required: true })
  readonly text!: string

  @Prop({ type: String, required: true })
  readonly address!: string

  @Prop({ type: String, required: true })
  readonly to!: string
}
